import React, { useState } from "react";
import Modal from "../../../../shared/components/dashboard-layout/modalComponent";
import "./add-member-modal.scss";

// Validation utilities
const validateForm = (formData) => {
  const errors = {};
  const { firstName, lastName, memberPhone } = formData;

  if (!firstName.trim()) {
    errors.firstName = "First name is required";
  }

  if (!lastName.trim()) {
    errors.lastName = "Last name is required";
  }

  if (!memberPhone.trim()) {
    errors.memberPhone = "Phone number is required";
  } else {
    const phoneRegex = /^\+?[\d\s\-\(\)]+$/;
    if (!phoneRegex.test(memberPhone.trim())) {
      errors.memberPhone = "Please enter a valid phone number";
    }
  }

  return errors;
};

const AddMemberModal = ({ onClose, onAddMember, groupName, isLoading, error }) => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    memberPhone: ""
  });
  const [errors, setErrors] = useState({});

  // Form handlers
  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
    // Clear error when user starts typing
    if (errors[field]) {
      setErrors(prev => ({ ...prev, [field]: "" }));
    }
  };

  const handleSubmit = (e) => {
    e?.preventDefault?.();
    const validationErrors = validateForm(formData);
    
    if (Object.keys(validationErrors).length === 0) {
      onAddMember({
        firstName: formData.firstName.trim(),
        lastName: formData.lastName.trim(),
        phone: formData.memberPhone.trim(),
      });
    } else {
      setErrors(validationErrors);
    }
  };

  const handleSave = (e) => {
    if (isLoading) return;
    handleSubmit(e);
  };

  const renderFormGroup = (field, label, type = "text", placeholder = "") => (
    <div className="form-group">
      <label htmlFor={field}>{label} *</label>
      <input
        type={type}
        id={field}
        value={formData[field]}
        onChange={(e) => handleInputChange(field, e.target.value)}
        placeholder={placeholder}
        className={errors[field] ? "error" : ""}
        autoComplete="off"
      />
      {errors[field] && (
        <span className="error-message">{errors[field]}</span>
      )}
    </div>
  );

  const renderForm = () => (
    <form onSubmit={handleSubmit} className="modal-form" style={{ padding: "0" }}>
      {renderFormGroup("firstName", "First Name", "text", "Enter first name")}
      {renderFormGroup("lastName", "Last Name", "text", "Enter last name")}
      {renderFormGroup("memberPhone", "Phone Number", "tel", "Enter phone number (e.g., +1234567890)")}

      <div className="alert alert-info d-flex align-items-center gap-2 my-1">
        <i className="fas fa-info-circle alert-info"></i>
        <span className="alert-info">Use E.164 format for phone numbers (use the country code, e.g., +14155552671)</span>
      </div>


      { error && 
        <div className="alert alert-danger d-flex align-items-center gap-2 my-1">
          <i className="fa fa-times alert-danger"></i>
          <span className="alert-danger">
            Failed to add member: <b className="alert-danger">{error}</b>
          </span>
        </div>
      }
    </form>
  );

  return (
    <Modal
      show={true}
      onClose={onClose}
      header={`Add Member to ${groupName}`}
      buttons={true}
      onSave={handleSave}
      saveLabel={isLoading ? "Adding..." : "Add Member"}
      saveDisabled={isLoading}
    >
      <div className="add-member-modal">
        {renderForm()}
      </div>
    </Modal>
  );
};

export default AddMemberModal;
